import { withJsonFormsControlProps } from "@jsonforms/react";
import { InputItem } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import { getTranslatedText } from "../../../utils/commons";

const SearchInputComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, uischema, path, data } = props;
  const { placeholder, size } = uischema;

  const returnArray = uischema?.returnArray || uischema?.options?.returnArray;

  const displayValue = Array.isArray(data) ? data[0] || "" : data || "";

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (returnArray) {
      const value = inputValue.trim() === "" ? [] : [inputValue];
      handleChange(path, value);
    } else {
      handleChange(path, inputValue);
    }
  };

  return (
    <div className="search-input-container mt-2 w-100 position-relative">
      <InputItem
        title={getTranslatedText(t, placeholder, placeholder)}
        placeholder={getTranslatedText(t, placeholder, placeholder) || ""}
        trailingIcon="search"
        inputSize={size || "medium"}
        value={displayValue}
        className="input-search"
        onChange={handleInputChange}
      />
    </div>
  );
};

export const SearchInputControl = withJsonFormsControlProps(SearchInputComponent);
